<ua-modal class="send-bp-modal">
  <div class='modal-header'>
    <div class='header-wrap'>
      <button class="close-wrapper unstyle-button" aria-labelledby="backBtn" (click)="closeModal()">
        <i (click)="closeModal()" aria-hidden="true" class="material-icons">arrow_back</i><span
          id="backBtn">{{commonConstants.back}}</span>
      </button>
      <div class='header-title'>
        <h4>{{rebookConstants.sendBPTitle}}</h4>
      </div>
    </div>
  </div>
  <div class='modal-body'>
    <div class='body-wrapper'>

      <form [formGroup]="userForm" class="phone-wrap" (ngSubmit)="onFormSubmit()">
        <div class='email-control-wrap'>
          <label>
            {{ commonConstants[email.label] }}
          </label>
          <div class='email-control'>
            <input type="email" class="form-control email" placeholder="{{email.placeholder}}"
              formControlName="email" />
            <div class="error-block" *ngIf="emailControl?.dirty && emailControl?.invalid">
              <div class="err-message" *ngIf="emailControl?.errors?.required" role="alert">
                <div class="error-icon">
                  <img src="./../../../assets/error.png" alt="error" />
                </div>
                <span>{{ rebookConstants[email.errors.required] }}</span>
              </div>
              <div class="err-message" *ngIf="emailControl?.errors?.pattern" role="alert">
                <div class="error-icon">
                  <img src="./../../../assets/error.png" alt="error" />
                </div>
                <span>{{ rebookConstants[email.errors.invalid] }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="seperator">
          <h4>{{ homeConstants.or }}</h4>
        </div>
        <div class="phone-control-wrap">
          <div class="phone">
            <div class="phone-code">
              <label>
                {{ commonConstants[phoneCode.label] }}
              </label>
              <select class="form-control" formControlName="code" [attr.aria-label]="rebookConstants.countryCodeLabel">
                <option *ngFor="let option of phoneCode.options" [value]="option?.value">{{ option?.label }}
                </option>
              </select>
            </div>
            <div class="phone-number">
              <label>
                {{ commonConstants[phoneNumber.label] }}
              </label>
              <input type="tel" class="form-control phoneCode" *ngIf="phoneCodeControl.value !== defaultCountryCode"
                [maxLength]="15" formControlName="number" autocomplete="off" />
              <input type="tel" class="form-control phoneCode" *ngIf="phoneCodeControl.value === defaultCountryCode"
                [placeholder]="phoneNumber.placeholder" [textMask]="phoneNumber.maskOptions" formControlName="number"
                autocomplete="off" [attr.aria-label]="rebookConstants.phoneNumberLabel" />
              <div class="error-block" *ngIf="phoneControl?.dirty && phoneControl?.invalid">
                <div class="err-message" *ngIf="phoneControl?.errors?.required" role="alert">
                  <div class="error-icon">
                    <img src="./../../../assets/error.png" alt="error" />
                  </div>
                  <span>{{ rebookConstants[phoneNumber.errors.required] }}</span>
                </div>
                <div class="err-message" *ngIf="phoneControl?.errors?.pattern" role="alert">
                  <div class="error-icon">
                    <img src="./../../../assets/error.png" alt="error" />
                  </div>
                  <span>{{ rebookConstants[phoneNumber.errors.invalid] }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-wrap">
          <button class="btn submit" [class.disabled]="checkValidity()"
            [disabled]="checkValidity()">{{rebookConstants.sendBP }}</button>
        </div>
      </form>
    </div>
  </div>
</ua-modal>